import { inject, Injectable } from "@angular/core";
import { UserBackofficeViewModel } from "@playcharge/common/models/backend/users/backoffice/user-backoffice-view-model";
import { Observable } from "rxjs";
import { ApiRoutes } from "../models/constants/api-routes";
import { ApiUtils } from "../utils/api-utils";
import { HttpClient, HttpParams } from "@angular/common/http";

@Injectable({
    providedIn: "root",
})
export class ApiUsersService {
    private _httpClient: HttpClient = inject(HttpClient);

    public getByEmail(email: string): Observable<UserBackofficeViewModel> {
        let queryParams: HttpParams = new HttpParams();
        queryParams = queryParams.append("email", email);

        return this._httpClient.get<UserBackofficeViewModel>(
            ApiUtils.buildUrl(ApiRoutes.users.root),
            { params: queryParams },
        );
    }

    public reapproveConversion(conversionId: number): Observable<void> {
        return this._httpClient.post<void>(
            ApiUtils.buildUrl(
                ApiRoutes.users.reapproveConversion,
                new Map([["conversionId", conversionId.toString()]]),
            ),
            null,
        );
    }
    public forceApproveConversion(conversionId: number, reason: string): Observable<void> {
        return this._httpClient.post<void>(
            ApiUtils.buildUrl(ApiRoutes.users.forceApproveConversion),
            { conversionId, reason },
        );
    }
    public balanceCorrection(email: string, amount: number, expAmount: number, reason: string): Observable<void> {
        return this._httpClient.post<void>(
            ApiUtils.buildUrl(ApiRoutes.users.balanceCorrection),
            { email, amount, expAmount, reason },
        );
    }
    public banUser(userId: number, reason: string): Observable<void> {
        return this._httpClient.post<void>(
            ApiUtils.buildUrl(ApiRoutes.users.banUser),
            { userId, reason },
        );
    }
    public unbanUser(userId: number, reason: string): Observable<void> {
        return this._httpClient.post<void>(
            ApiUtils.buildUrl(ApiRoutes.users.unbanUser),
            { userId, reason },
        );
    }
}
